import { render, staticRenderFns } from "./ReviewReportCommentsView.vue?vue&type=template&id=3daed53e&scoped=true&"
import script from "./ReviewReportCommentsView.vue?vue&type=script&lang=js&"
export * from "./ReviewReportCommentsView.vue?vue&type=script&lang=js&"
import style0 from "./ReviewReportCommentsView.vue?vue&type=style&index=0&id=3daed53e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3daed53e",
  null
  
)

export default component.exports